
function EndorsementsPage() {
  return (
    <main className="bg-white py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Page Title */}
        <h1 
          className="text-5xl font-bold text-center mb-12 text-black" 
          style={{ fontFamily: 'Poppins, sans-serif' }}
        >
          Endorsed by:
        </h1>
        
        {/* Endorsements Section */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto mb-16">
          {/* Left Column - Image */}
          <div className="flex items-center justify-center">
            <div className="w-full max-w-lg">
              <img
                src="//img1.wsimg.com/isteam/ip/825d56ba-0d92-4fe9-9887-df9195c758ea/TXGOPEndorsementScottHigg.JPEG/:/cr=t:0%25,l:0%25,w:100%25,h:100%25/rs=w:1023,cg:true"
                alt="Texas GOP Endorsement"
                className="w-full rounded shadow-lg"
              />
            </div>
          </div>
          
          {/* Right Column - Endorsement List */}
          <div className="flex flex-col justify-center">
            <div className="space-y-6 text-black text-xl">
              <p>Republican Party of Texas</p>
              <p>Galveston County Republican Party</p>
              <p>County Commissioner Darrell Apffel</p>
              <p>County Commissioner Hank Dugie</p>
              <p>League City Mayor Nick Long</p>
            </div>
          </div>
        </div>
        
        {/* Contact for more information */}
        <div className="max-w-3xl mx-auto mb-16 text-center">
          <p className="text-lg text-black mb-6">
            Scott Higginbotham is proud to be endorsed by leaders who share his commitment to conservative 
            values and responsible governance for League City.
          </p>
          
          <div className="mt-8">
            <a
              href="/contact"
              className="inline-block bg-black text-white font-bold py-3 px-8 rounded-full hover:bg-indigo-800 transition"
            >
              CONTACT US
            </a>
          </div>
        </div>
        
      </div>
    </main>
  );
}

export default EndorsementsPage;